"use client";
import { useEffect } from "react";
import { useHeader } from "@/hooks/headerContext";

export default function VenueListSearchParams(props: SearchProps) {
  const { onChange } = useHeader();

  const formatData = (data) => {
    if (!data) return {};
    
    return {
      id: data?.id,
      title: data?.title || data?.descriptions?.[0]?.title,
      slug: data?.slug || data?.descriptions?.[0]?.slug,
    }
  }

  useEffect(() => {
    onChange("district", formatData(props.districtData))
    onChange("service", formatData(props.serviceData))
  }, [props.districtData, props.serviceData]);

  return null;
}
